import { Tier } from "graphql_globals";

export const TIER_NAME = Object.freeze({
  BASIC: "Basic Tier",
  PRO: "Pro Tier",
  PRO_TRIAL: "Pro Trial Tier",
  BUSINESS_PRO_IHN: "Business Pro with IHN Default",
  BUSINESS_PRO_ODN: "Business Pro only ODN Default",
  ELITE: "Elite Tier",
  TITLE_AGENT: "Title - Individual Agent Tier",
  TITLE_AGENCY_PRO: "Title Agency Pro",
  TITLE_PRO_ODN: "Title Pro Only ODN Default",
  TITLE_PRO_IHN: "Title Pro with IHN Default",
  TITLE_AGENCY_PRO_NOTARY: "Title Agency Pro with Notaries",
});

export const TIER_PATH = Object.freeze({
  BASIC: "starter",
  PRO: "pro",
  PRO_TRIAL: "pro-trial",
  BUSINESS_PRO_IHN: "proihn",
  BUSINESS_PRO_ODN: "proodn",
  ELITE: "premium",
  TITLE_AGENT: "title-agency",
  TITLE_AGENCY_PRO: "title-pro",
  TITLE_PRO_ODN: "title-proodn",
  TITLE_PRO_IHN: "title-proihn",
  TITLE_AGENCY_PRO_NOTARY: "title-pro-notary",
  NOTARY_MARKETPLACE_BASIC: "notary_basic",
});

export const PRO_TIERS = Object.freeze([
  Tier.BUSINESS_PRO_IHN,
  Tier.BUSINESS_PRO_ODN,
  Tier.TITLE_PRO_IHN,
  Tier.TITLE_PRO_ODN,
] as const);
